import _ from 'lodash'

import { useUserProgress } from '@/shared/contexts/UserProgress'
import { api } from '@/shared/services/api'

interface FinishResourceParams {
  type: string
  id: string | number
  action: string
  meta?: Record<string, any>
}

export const useFinishResource = () => {
  const { refetchProgress } = useUserProgress()

  const finishResource = async ({
    type,
    id,
    action,
    meta = {}
  }: FinishResourceParams): Promise<void> => {
    if (!type || !id || (!action && !meta && _.isEmpty(meta)))
      throw new Error('Missing required parameters on handleFinishResource')

    try {
      await api.post(`/user/progress/finish_resource`, {
        record: {
          resource_type: type,
          resource_id: id,
          meta: {
            [action]: true,
            ...meta
          }
        }
      })

      refetchProgress()
    } catch (error) {
      // Você pode tratar o erro aqui se quiser, ex: mostrar toast
    }
  }

  return { finishResource }
}
